const LAST_OFFER_LAYOUT_KEY = 'opendate.offerLayout';
const DEFAULT_OFFER_LAYOUT = 'simple';
const VALID_OFFER_LAYOUTS = ['advanced', 'simple'];

export const readLastOfferLayout = () => {
  try {
    const stored = window.localStorage.getItem(LAST_OFFER_LAYOUT_KEY);
    return VALID_OFFER_LAYOUTS.includes(stored) ? stored : DEFAULT_OFFER_LAYOUT;
  } catch (e) {
    return DEFAULT_OFFER_LAYOUT;
  }
};

export const writeLastOfferLayout = (layout) => {
  if (!VALID_OFFER_LAYOUTS.includes(layout)) {
    return;
  }
  try {
    window.localStorage.setItem(LAST_OFFER_LAYOUT_KEY, layout);
  } catch (e) {
    // localStorage may be unavailable (private mode / SSR) — non-fatal.
  }
};
